import {
    CLOSE_WINDOW,
    LIKE,
    YOU_DONT_HAVE_RIGHTS_TO_SEE_WHO_LIKED_THIS_COMMENT,
    YOU_DONT_HAVE_RIGHTS_TO_SEE_WHO_LIKED_THIS_POST,
} from 'mk/autogenerated/translations/LikeInfoPopup.ead949fb3ea3f74cab2fdcffe09a8ae8'
import { likeInfoFetchTrigger } from 'mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.actions';
import reducer, { LikeInfoPopupState } from 'mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.reducers';
import saga from 'mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.sagas';
import { getLikeInfoPopupState } from 'mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.selectors';
import { blogsProfileUrl } from 'mk2/apps/blogs/urls';
import AvatarImg from 'mk2/components/AvatarImg';
import Btn, { BtnType } from 'mk2/components/Btn';
import NoResults from 'mk2/components/NoResults';
import LoadingSwitch from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import registerInStore from 'mk2/decorators/registerInStore';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import { AppState } from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity, UserSchema } from 'mk2/schemas';
import { getDenormalizedEntities } from 'mk2/selectors';
import React from 'react';
import { connect } from 'react-redux';
import styles from './LikeInfoPopup.mscss';

interface OwnProps {
    entityType: string;
    entityId: number;
    linkAccessKey?: string;  // pouziva sa v blogoch na pristup k privatnym postom bez loginu

    onHide();
}

interface StateProps {
    likers: UserEntity[];
    loadingState: LoadingState;
}

interface DispatchProps {
    onLoad(entityType: string, entityId: number, linkAccessKey?: string);
}

class LikeInfoPopup extends React.Component<OwnProps & StateProps & DispatchProps> {

    public render() {
        const { likers, onHide, loadingState } = this.props;

        return (
            <div className={styles.LikeInfoPopup}>
                <div className={styles.LikeInfoPopup__header}>
                    {LIKE}
                    <Btn
                        className={styles.LikeInfoPopup__close}
                        type={BtnType.BlueText}
                        label={CLOSE_WINDOW}
                        onClick={onHide}
                    />
                </div>

                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderLoadSuccess}
                    onRenderFailure={this.renderLoadFailure}
                    hasData={!!likers && likers.length > 0}
                />

            </div>
        );
    }

    private load = () => {
        const { entityType, entityId, linkAccessKey, onLoad } = this.props;
        onLoad(entityType, entityId, linkAccessKey);
    };

    private renderLoadSuccess = () => {
        const { likers } = this.props;

        return (
            <React.Fragment>
                {likers.map((liker) => (
                    <span
                        className={styles.LikeInfoPopup__item}
                        title={liker.username}
                        key={liker.id}
                    >
                        <AvatarImg
                            size={32}
                            user={liker}
                            href={url(blogsProfileUrl, { username: liker.username })}
                        />
                        <div className={styles.LikeInfoPopup__item__username}>
                            {liker.username}
                        </div>
                    </span>
                ))}
            </React.Fragment>
        );
    };

    private renderLoadFailure = () => {
        const { entityType } = this.props;

        return (
            <NoResults
                noIcon
                className={styles.LikeInfoPopup__error}
                message={entityType === 'comment'
                    ? YOU_DONT_HAVE_RIGHTS_TO_SEE_WHO_LIKED_THIS_COMMENT
                    : YOU_DONT_HAVE_RIGHTS_TO_SEE_WHO_LIKED_THIS_POST
                }
            />
        );
    };

}

function mapStateToProps(state: AppState, ownProps: OwnProps): StateProps {
    const { entityType, entityId } = ownProps;
    const lipState: LikeInfoPopupState = getLikeInfoPopupState(state, entityType, entityId);
    const likers: UserEntity[] = getDenormalizedEntities<UserEntity>(state, UserSchema, lipState.likerUserIds);

    return {
        likers,
        loadingState: lipState.loadingState,
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {
    onLoad: likeInfoFetchTrigger,
};

export default registerInStore<OwnProps>((store) => {
    store.injectReducer('containers.blogs.shared.likeInfoPopups', reducer);
    store.injectSaga('containers.blogs.shared.likeInfoPopups', saga);
})(connect(mapStateToProps, mapDispatchToProps)(LikeInfoPopup));
